import { useEffect } from 'react'
import { X } from 'react-feather'
import styled, { css, useTheme } from 'styled-components/macro'
import {BREAKPOINTS} from "theme";
import { colors } from 'theme/colors'

import { useRemovePopup } from '../../state/application/hooks'
import { PopupContent } from '../../state/application/reducer'
import {useCombinedActiveList} from "../../state/lists/hooks";
import {useTransaction} from "../../state/transactions/hooks";
import {parseLocalActivity} from "../AccountDrawer/MiniPortfolio/Activity/parseLocal";
import FailedNetworkSwitchPopup from './FailedNetworkSwitchPopup'
import TransactionPopup from './TransactionPopup'
import {useAccount} from "wagmi";

const StyledClose = styled(X)<{ $padding: number; $swap?: boolean }>`
  position: absolute;
  right: ${({ $padding }) => `${$padding}px`};
  top: ${({ $padding }) => `${$padding}px`};
  padding: 4px;
  min-width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${colors.gray550};
  stroke: ${colors.white};

  @media (max-width: ${BREAKPOINTS.md}px) {
    position: ${({ $swap }) => ($swap ? 'absolute' : 'relative')};
    top: ${({ $swap, $padding }) => ($swap ? `${$padding}px` : 0)};
  }

  :hover {
    cursor: pointer;
  }
`
const PopupCss = css<{ show: boolean; $swap?: boolean }>`
  display: ${({ $swap }) => ($swap ? 'inline-block' : 'flex')};
  align-items: center;
  width: 100%;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  background-color: ${({ theme }) => theme.background};
  position: relative;
  border: 1px solid ${({ theme }) => theme.borderPrimary};
  border-radius: 24px;
  overflow: hidden;
  transition: ${({ theme }) => `visibility ${theme.transition.duration.fast} ease-in-out`};

  ${({ theme }) => theme.deprecated_mediaWidth.deprecated_upToSmall`
  min-width: 340px;
  &:not(:last-of-type) {
    margin-right: 20px;
  }
`}
`

const TransactionPopupContainer = styled.div`
  ${PopupCss}
  padding: 2px 0px;
`

const FailedSwitchNetworkPopupContainer = styled.div`
  ${PopupCss}
  padding: 20px 35px 20px 20px;
`

export default function PopupItem({
  removeAfterMs,
  content,
  popKey,
}: {
  removeAfterMs: number | null
  content: PopupContent
  popKey: string
}) {
  const removePopup = useRemovePopup()
  const hash = 'txn' in content ? content.txn.hash : undefined
  const tx = useTransaction(hash)
  const { chainId } = useAccount()
  const isSuccessStatus = tx?.receipt?.status === 1
  const tokens = useCombinedActiveList()
  const activity = tx && chainId ? parseLocalActivity(tx, chainId, tokens) : undefined
  const theme = useTheme()

  useEffect(() => {
    if (removeAfterMs === null) return undefined

    const timeout = setTimeout(() => {
      removePopup(popKey)
    }, removeAfterMs)

    return () => {
      clearTimeout(timeout)
    }
  }, [popKey, removeAfterMs, removePopup])

  if ('txn' in content) {
    return (
      <TransactionPopupContainer show={true} $swap={activity?.title === 'Swapped' && isSuccessStatus}>
        <TransactionPopup hash={content.txn.hash} />
        <StyledClose $padding={20} $swap={activity?.title === 'Swapped' && isSuccessStatus} color={theme.iconPrimary} onClick={() => removePopup(popKey)} />
      </TransactionPopupContainer>
    )
  } else if ('failedSwitchNetwork' in content) {
    return (
      <FailedSwitchNetworkPopupContainer show={true}>
        <StyledClose $padding={20} color={theme.textSecondary} onClick={() => removePopup(popKey)} />
        <FailedNetworkSwitchPopup chainId={content.failedSwitchNetwork} />
      </FailedSwitchNetworkPopupContainer>
    )
  }
  return null
}
